// extracted by mini-css-extract-plugin
export default {"container":"CadastrarPessoa_container__9P+1H","card":"CadastrarPessoa_card__GfkzK"};